import YkcAutocomplete from './src/ykc-autocomplete.vue';

YkcAutocomplete.install = function install(_vue) {
  _vue.component(YkcAutocomplete.name, YkcAutocomplete);
};
export default YkcAutocomplete;
